module.exports = __webpack_public_path__ + "static/media/luxtrust-mobile@2x.30a1f363.png";